<template>
    <BaseBoxSection :title="__('contract_settlement')" :helpName="helpName">
        <LeftToBeInvoicedTable
            v-if="!contract.detailed"
            :contractItemsSummaries="contractBlanketItemsSummaries"
            :contractType="contract.type"
            :detailed="false"
        />
        <LeftToBeInvoicedDetailedTable
            v-else
            :contractDetailedItemsSummaries="contractDetailedItemsSummaries"
            :contractType="contract.type"
            :detailed="true"
        />
        <AdvanceToBeSettledTable
            :contractItemsSummaries="contractBlanketItemsSummaries"
            :contractType="contract.type"
        />
        <div class="col-12 text-right mt-2">
            <button
                v-if="!contract.advancedPaymentIsFinal && (contract.type.in_droplist == 'invoice_pl' ?  getPermission('perm_route_records.contracts.edit-pl') : getPermission('perm_route_records.contracts.edit-adding'))"
                :disabled="!isActiveIncludeInIncomeExpenses"
                class="btn btn-primary btn-sm ml-1"
                type="button"
                @click="includeInIncomeExpenses"
            >
                {{ __('include_in_income_expenses') }}
            </button>
            <button
                v-else-if="contract.advancedPaymentIsFinal && (contract.type.in_droplist == 'invoice_pl' ?  getPermission('perm_route_records.contracts.edit-pl') : getPermission('perm_route_records.contracts.edit-adding'))"
                class="btn btn-primary btn-sm ml-1"
                type="button"
                @click="revokeRecognitionOfIncomeExpenses"
            >
                {{ __('revoke_recognition_of_income_expenses') }}
            </button>
        </div>
    </BaseBoxSection>
</template>

<script>
import BaseBoxSection from "../BaseBoxSection";
import AdvanceToBeSettledTable from "../tables/contract/AdvanceToBeSettled/AdvanceToBeSettledTable";
import LeftToBeInvoicedTable from "../tables/contract/LeftToBeInvoiced/LeftToBeInvoicedTable";
import actions from "../../vuex/action_types";
import LeftToBeInvoicedDetailedTable from "../tables/contract/LeftToBeInvoiced/LeftToBeInvoicedDetailedTable";
import hasPermissions from "../../mixins/hasPermissions";
import hasTooltips from "../../mixins/hasTooltips";
import inputEmit from "../../mixins/inputEmit";
import hasErrors from "../../mixins/hasErrors";

export default {
    name: "ContractSettlement",
    components: {LeftToBeInvoicedDetailedTable, LeftToBeInvoicedTable, AdvanceToBeSettledTable, BaseBoxSection},
    props: {
        contract: {
            type: Object,
            required: true,
        },
        contractDetailedItemsSummaries: {
            type: Object | Array,
            required: true,
        },
        contractBlanketItemsSummaries: {
            type: Object|Array,
            required: true,
        },
        helpName: {
            type: String,
            required: true,
        },
    },
    mixins: [hasPermissions],
    computed: {
        isActiveIncludeInIncomeExpenses() {
            return this.contract.canIncludeInIncomeExpenses;
        },
    },
    methods: {
        async sendRequest(storeAction) {
            try {
                toggleLoader(true);
                const {data} = await this.$store.dispatch(storeAction, this.contract.id);
                toastr.success(data);
                window.location.reload();
            } catch ({response}) {
                toastr.error(`${response.status}: ${response.statusText}`);
                toggleLoader(false);
            }
        },
        async includeInIncomeExpenses() {
            await this.sendRequest(actions.INCLUDE_IN_INCOME_EXPENSES);
        },
        async revokeRecognitionOfIncomeExpenses() {
            await this.sendRequest(actions.REVOKE_RECOGNITION_OF_INCOME_EXPENSES);
        },
    },
};
</script>
